import { Controller } from "@hotwired/stimulus";
import { get } from "@rails/request.js";

// Connects to data-controller="create-listing-from-product"
export default class extends Controller {
  static outlets = ["polaris-autocomplete", "polaris-button"];
  static targets = ["productIdField"];
  static values = { productId: String };

  connect() {
    if (this.productIdValue) {
      this.continueButtonOutlet.enable();
    }
  }

  productIdFieldTargetConnected(target) {
    target.addEventListener(
      "polaris-autocomplete:change",
      this.onProductChanged,
    );

    this.polarisAutocompleteOutlet.inputTarget.addEventListener(
      "input",
      this.onProductInputChanged,
    );

    this.polarisAutocompleteOutlet.inputTarget.addEventListener(
      "blur",
      this.onProductInputBlurred,
    );
  }

  productIdFieldTargetDisconnected(target) {
    target.removeEventListener(
      "polaris-autocomplete:change",
      this.onProductChanged,
    );
    if (this.hasPolarisAutocompleteOutlet) {
      this.polarisAutocompleteOutlet.inputTarget.removeEventListener(
        "input",
        this.onProductInputChanged,
      );
      this.polarisAutocompleteOutlet.inputTarget.removeEventListener(
        "blur",
        this.onProductInputBlurred,
      );
    }
  }

  onProductChanged = (eventData) => {
    const productId = eventData.detail.value;
    this.productIdValue = productId;

    if (this.productIdValue) {
      this.continueButtonOutlet.enable();
    }
  };

  onProductInputChanged = (event) => {
    if (event.target.value === "") {
      const autocompleteOutlet = this.polarisAutocompleteOutlet;

      if (autocompleteOutlet) {
        if (autocompleteOutlet.hasHiddenInputTarget) {
          autocompleteOutlet.hiddenInputTarget.value = "";
        }
        if (autocompleteOutlet.hasInputTarget) {
          autocompleteOutlet.inputTarget.value = "";
        }

        autocompleteOutlet.reset();
      }

      this.continueButtonOutlet.disableWithoutLoader(event);
    }
  };

  onProductInputBlurred = (event) => {
    const autocompleteOutlet = this.polarisAutocompleteOutlet;

    const selectedValue = autocompleteOutlet.hiddenInputTarget.value;

    const selectedOption = autocompleteOutlet.visibleOptions.find((option) => {
      const input = option.querySelector("input");

      return input.value === selectedValue;
    });

    if (selectedOption) {
      if (event.target.value !== selectedOption.dataset.label) {
        event.target.value = selectedOption.dataset.label;
      }
    }
  };

  createProductManually() {
    get(`/retailer/product_listings/product_categories`, {
      responseKind: "turbo-stream",
    });
  }

  handleSubmit(event) {
    this.continueButtonOutlet.disable(event);
    get(
      `/retailer/product_listings/variants?product_id=${this.productIdValue}`,
      {
        responseKind: "turbo-stream",
      },
    );
  }

  get addProductManuallyButtonOutlet() {
    return this.polarisButtonOutlets.find(
      (outlet) => outlet.element.id === "add-product-manually-button",
    );
  }

  get continueButtonOutlet() {
    return this.polarisButtonOutlets.find(
      (outlet) => outlet.element.id === "continue-button",
    );
  }
}
